module.exports = __webpack_public_path__ + "media/images/athletes/1680-769d3f5c8e904ce7430b5fbb190d41fa.png";